import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Toaster } from "sonner";
import "@/App.css";
import { BottomNav } from "@/components/BottomNav";
import { Scanner } from "@/components/Scanner";
import { Diario } from "@/components/Diario";
import { Profilo } from "@/components/Profilo";
import { Preferiti } from "@/components/Preferiti";
import { ChefOggi } from "@/components/ChefOggi";
import { SosButton } from "@/components/SosButton";
import { loadProfile, saveProfile, loadMeals } from "@/lib/mbStorage";

function App() {
  const [screen, setScreen] = useState("scanner");
  const [profile, setProfile] = useState(loadProfile());
  const [meals, setMeals] = useState(loadMeals());
  const [fromInstagram, setFromInstagram] = useState(false);

  useEffect(() => {
    saveProfile(profile);
  }, [profile]);

  // Rileva l'arrivo da Instagram (utm_source) e mostra un saluto di benvenuto.
  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      const src = params.get("utm_source");
      if (src) localStorage.setItem("mb_utm_source", src);
      const source = src || localStorage.getItem("mb_utm_source");
      if (source === "instagram" && !localStorage.getItem("mb_insta_welcome_dismissed")) {
        setFromInstagram(true);
      }
    } catch { /* localStorage non disponibile */ }
  }, []);

  const dismissInstaWelcome = () => {
    try {
      localStorage.setItem("mb_insta_welcome_dismissed", "1");
    } catch { /* ignore */ }
    setFromInstagram(false);
  };

  const refreshMeals = () => setMeals(loadMeals());

  const isTouch =
    typeof window !== "undefined" &&
    (("ontouchstart" in window) || navigator.maxTouchPoints > 0);

  return (
    <div className={`mb-app-bg ${isTouch ? "is-touch" : ""}`}>
      <div className="mb-app-shell bg-gradient-to-b from-[#f0f7ff] to-white">
        {/* Notch (solo desktop) */}
        <div className="mb-notch" />

        <div
          className="mb-app-scroll overflow-x-hidden px-4"
          style={{
            paddingTop: "calc(1.5rem + env(safe-area-inset-top))",
            paddingBottom: "calc(9.5rem + env(safe-area-inset-bottom))",
          }}
        >
          <motion.div
            key={screen}
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.28 }}
          >
            {screen === "scanner" && (
              <Scanner profile={profile} onMealAdded={refreshMeals} onOpenChef={() => setScreen("chef")} fromInstagram={fromInstagram} onDismissWelcome={dismissInstaWelcome} />
            )}
            {screen === "chef" && (
              <ChefOggi profile={profile} onBack={() => setScreen("scanner")} />
            )}
            {screen === "diario" && (
              <Diario
                profile={profile}
                meals={meals}
                onProfileChange={setProfile}
                onMealsChange={setMeals}
              />
            )}
            {screen === "progressi" && (
              <Profilo profile={profile} onProfileChange={setProfile} />
            )}
            {screen === "preferiti" && <Preferiti />}
          </motion.div>
        </div>

        <BottomNav current={screen} onChange={setScreen} />
        <SosButton />
        <Toaster position="top-center" richColors />
      </div>
    </div>
  );
}

export default App;
